import React, { useContext, useEffect, useState } from 'react';
import { Form } from 'informed';
import axios from 'axios';
import { API_HOST } from '../../consts';
import InputSelect from '../../components/inputs/InputSelect';
import { toast } from 'react-toastify';
import { withTheme } from 'styled-components';
import { Grid } from '@material-ui/core';
import { FilterRelatorioContext } from '../../contexts/FilterRelatorioProvider/Context';
import { get } from 'lodash';

const FORM_INITIAL_STATE = {
  dreOptions: null,
  ano: null,
  periodo: null,
  etapaOptions: null,
  disciplinaOptions: null
};

const FilterRelatorioDre = ({ dre, buttonRelatorio, ...props }) => {
  const { setStateFilters } = useContext(FilterRelatorioContext);
  const [state, setState] = useState({
    me: null,
    loading: true,
    isLoading: false,
    isPlaceholder: 'Selecione',
    metadataAvalia: {}
  });
  const [formApi, setFormApi] = useState(null);
  const [formInputData, setFormInputData] = useState({});

  const performUpdate = (newData) => {
    setFormInputData((prevState) => ({ ...prevState, ...newData }));
  };

  const mapMetadataAvalia = (metadata) => {
    const mapped = {};
    metadata.forEach((m) => {
      mapped[`${m.model}.${m.name}`] = m.value;
    });
    return mapped;
  };

  const fetchMetadataAvalia = async () => {
    try {
      const response = await axios.get(`${API_HOST}/params/param?model=avalia`);
      setState((prevState) => ({
        ...prevState,
        metadataAvalia: mapMetadataAvalia(response.data)
      }));
    } catch (error) {
      console.error(error.message);
    }
  };

  const fetchAno = async () => {
    try {
      const response = await axios.get(`${API_HOST}/avalia/ano`);
      performUpdate({
        anoOptions: response.data.map((d) => ({
          value: d.id,
          label: d.ds_ano
        }))
      });
    } catch (error) {
      toast.error('Nenhum ano encontrado');
      console.error(error.message);
    }
  };

  const fetchPeriodo = async () => {
    setState((prevState) => ({ ...prevState, isLoading: true }));
    try {
      const response = await axios.get(`${API_HOST}/avalia/periodo`);
      performUpdate({
        periodoOptions:
          response &&
          response.data.map((d) => ({
            value: d.id,
            label: d.ds_periodo
          }))
      });
      setState((prevState) => ({ ...prevState, isLoading: false }));
    } catch (error) {
      toast.error('Nenhum período encontrado');
      console.error(error.message);
    }
  };

  const fetchAnoPeriodo = async (prova, ano) => {
    try {
      const response = await axios.get(
        `${API_HOST}/avalia/periodo_ano?periodo__id=${prova}&ano__id=${ano}`
      );
      if (response.data.length < 0) {
        toast.error('Nenhum período de ano encontrado');
      }
      performUpdate({ periodoAno: response.data[0].id });
      await fetchEtapaFiltered( response.data[0].id );
    } catch (error) {
      toast.error('Nenhuma prova encontrada');
      console.error(error.message);
    }
  };

  const fetchDres = async (me) => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(
        `${API_HOST}/core/rede_dre_inst/${me}/get_dres`,
        {
          headers: {
            Authorization: `JWT ${token}`
          }
        }
      );
      performUpdate({
        dres: response.data.dre.map((d) => ({
          id: d.cd_dre,
          value: d.ds_dre,
          label: d.ds_dre,
          ...d
        }))
      });
    } catch (error) {
      const dreLabel =
        get(state, 'metadataAvalia.avalia.estado', '').toLowerCase() === 'rj'
          ? 'DRP'
          : 'DRE';
      toast.error(`Nenhum ${dreLabel} encontrado`);
      console.error(error.message);
    }
  };

  const fetchDresAdm = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${API_HOST}/avalia/dre`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      });
      performUpdate({
        dres: response.data.map((d) => ({
          ...d,
          id: d.external_id,
          value: d.dre_name,
          label: d.dre_name,
        }))
      });
    } catch (error) {
      const dreLabel =
        get(state, 'metadataAvalia.avalia.estado', '').toLowerCase() === 'rj'
          ? 'DRP'
          : 'DRE';
      toast.error(`Nenhum ${dreLabel} encontrado`);
      console.error(error.message);
    }
  };

  const fetchEtapaEscola = async (cdEscola) => {
    const { periodo } = formApi.getState().values;
    if (cdEscola) {
      try {
        performUpdate({ dreId: cdEscola.id });
        const response = await axios.get(
          `${API_HOST}/avalia/etapa/get_all_etapa`
        );
        const data = response.data.map((d) => ({
          value: d.nr_etapa,
          label: d.etapa,
          ...d
        }));
        var valuesToKeep = [2, 5, 9, 13];
        var filteredArray = data.filter(function (item) {
          return valuesToKeep.includes(item.nr_etapa);
        });
        const etapaOptionsValues = periodo === 4 ? filteredArray : data;
        performUpdate({ etapaOption: etapaOptionsValues });
      } catch (error) {
        toast.error(error);
      }
    }
  };

  const fetchEtapaEscolaDn = async (cdEscola) => {
    if (cdEscola) {
      try {
        performUpdate({ dreId: cdEscola.id });
        const response = await axios.get(
          `${API_HOST}/avalia/etapa/get_all_etapa`
        );
        const data = response.data.map((d) => ({
          value: d.nr_etapa,
          label: d.etapa,
          ...d
        }));
        performUpdate({ etapaOption: data });
      } catch (error) {
        toast.error(error);
      }
    }
  };

  const fetchEtapaFiltered = async (periodoAnoId) => {
    const { periodo } = formApi.getState().values;
    const params = {
      dre_id: formInputData.dreId,
      periodo_ano_id: periodoAnoId
    };
    try {
      const response = await axios.get(`${API_HOST}/avalia/etapa-input`, {
        params
      });
      const data = response.data.map((d) => ({
        value: d.nr_etapa,
        label: d.etapa,
        ...d
      }));
      performUpdate({ etapaOption: data });
    } catch (error) {
      toast.error(error);
    }
  };

  const fetchDisciplinas = (disciplina) => {
    performUpdate({
      EtapaNumero: disciplina.value,
      cd_turma: disciplina.cd_turma,
      currentEscola: disciplina.cd_escola
    });
    const { periodo } = formApi.getState().values;
    axios
      .get(`${API_HOST}/avalia/disciplina`)
      .then((res) => {
        const data = res.data.results.map((d) => ({
          value: d.id,
          label: d.disciplina,
          ...d
        }));

        let filteredArray = data;

        if (disciplina.value === 2 || disciplina.value === 5) {
          if (periodo === 4) {
            const valuesToKeep = [1, 2];
            filteredArray = data.filter((item) =>
              valuesToKeep.includes(item.id)
            );
          }
        } else if (disciplina.value === 9 && periodo === 4) {
          const valuesToKeep = [1, 2, 3, 4];
          filteredArray = data.filter((item) => valuesToKeep.includes(item.id));
        }

        performUpdate({
          disciplinaOptions: filteredArray
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fetchDisciplinasDn = (disciplina) => {
    performUpdate({
      EtapaNumero: disciplina.value,
      cd_turma: disciplina.cd_turma,
      currentEscola: disciplina.cd_escola
    });
    axios
      .get(`${API_HOST}/avalia/disciplina`)
      .then((res) => {
        const data = res.data.results.map((d) => ({
          value: d.id,
          label: d.disciplina,
          ...d
        }));
        performUpdate({ disciplinaOptions: data });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fetchMe = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      });
      setState((prevState) => ({ ...prevState, me: response.data }));
      let groups = response.data.logged_group.map((f) => {
        return f.toUpperCase();
      });
      if (groups.includes('ADMINISTRADOR')) {
        fetchDresAdm();
      } else {
        fetchDres(response.data.id);
      }
    } catch (error) {
      toast.error('Dados de acesso não encontrados');
      console.error(error.message);
    }
  };

  useEffect(() => {
    const mountFetchs = async () => {
      await fetchMetadataAvalia();
      await fetchMe();
      await fetchAno();
      setState((prevState) => ({ ...prevState, loading: false }));
    };
    mountFetchs();
  }, []);

  const isValidForm = () => {
    let isValidForm = true;
    let formValues = formApi.getState().values;
    Object.keys(formValues).forEach((key) => {
      if (!dre && key === 'dreOptions'){
        return;
      }
      if (!isValidField(formValues[key])) {
        formApi.setError(key, ['O campo é obrigatório']);
        isValidForm = false;
      }
    });
    return isValidForm;
  };

  const submitForm = (e) => {
    e.preventDefault();
    if (isValidForm()) {
      setStateFilters({ ...formInputData, isFormSubmit: true });
    } else {
      setStateFilters({ fecth: false });
    }
  };

  const isValidField = (fieldValue) => {
    if (fieldValue === null || fieldValue === undefined || fieldValue === '') {
      return false;
    }
    return true;
  };

  const legenda = 'Rede de Ensino';
  const isRj =
    get(state, 'metadataAvalia.avalia.estado', '').toLowerCase() === 'rj';
  const areaLabel = isRj ? 'Disciplina' : 'Área do Conhecimento';

  return (
    <>
      {state.loading ? (
        <div
          style={{
            width: '100%',
            height: `100%`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <img
            src={get(props.theme, 'loadingGif')}
            alt="loading"
            style={{ height: '50px' }}
          />
        </div>
      ) : (
        <div className="container filtro-dre">
          <Form
            key={`form-${FORM_INITIAL_STATE.dreOptions}`}
            getApi={(formApi) => {
              setFormApi(formApi);
            }}
            initialValues={FORM_INITIAL_STATE}
          >
            <Grid className="filtro-dre" container xs={12}>
              {dre && (
                <Grid item xs={12} md={3}>
                  <InputSelect
                    key={'input-select-dre'}
                    label={legenda}
                    field="dreOptions"
                    onChange={(e) => {
                      formApi.setValue('ano', '');
                      dre
                        ? fetchEtapaEscola(e)
                        : fetchEtapaEscolaDn(state.me.id, e.id);
                    }}
                    options={formInputData.dres}
                    required
                  />
                </Grid>
              )}

              <Grid item xs={12} md={3}>
                <InputSelect
                  key={`key-ano`}
                  label="Ano"
                  field="ano"
                  onChange={(e) => {
                    formApi.setValue('periodo', '');
                    if (e) {
                      fetchPeriodo();
                      performUpdate({ ano: e.value });
                    }
                  }}
                  options={formInputData.anoOptions}
                  required
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <InputSelect
                  key={'periodo-select'}
                  label="Avaliação"
                  field="periodo"
                  onChange={(e) => {
                    formApi.setValue('etapaOptions', '');
                    if (e) {
                      performUpdate({ periodo: e.value });
                      fetchAnoPeriodo(e.value, formInputData.ano);
                    }
                  }}
                  options={formInputData.periodoOptions}
                  required
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <InputSelect
                  key={'etapaOptions-select-dre'}
                  label="Série/Ano "
                  field="etapaOptions"
                  onChange={(e) => {
                    formApi.setValue('disciplinaOptions', '');
                    dre ? fetchDisciplinas(e) : fetchDisciplinasDn(e);
                  }}
                  options={formInputData.etapaOption}
                  required
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <InputSelect
                  key={'disciplinaOptions-select'}
                  label={areaLabel}
                  field="disciplinaOptions"
                  onChange={(e) => {
                    if (e) {
                      performUpdate({ DisciplinaID: e.value });
                    }
                  }}
                  options={formInputData.disciplinaOptions}
                  required
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={3}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: '10px'
                }}
              >
                <button
                  id="submit-from"
                  style={{
                    color: 'white',
                    backgroundColor: props.theme.primary,
                    border: 'none',
                    fontSize: '16px',
                    fontWeight: '600',
                    textAlign: 'center',
                    cursor: 'pointer',
                    borderRadius: '15px',
                    boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                    letterSpacing: '1px',
                    padding: '4px 16px',
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginLeft: '10px'
                  }}
                  onClick={(e) => {
                    submitForm(e);
                  }}
                >
                  Gerar Relatório
                </button>
              </Grid>

              <div
                style={{
                  background: '#bebebe',
                  width: '100%',
                  height: '1px',
                  marginTop: '1rem'
                }}
              />
            </Grid>
          </Form>
        </div>
      )}
    </>
  );
};

FilterRelatorioDre.contextType = FilterRelatorioContext;
export default withTheme(FilterRelatorioDre);
